import React, { FC } from 'react';

import { ReactComponent as LaunchIcon } from '../../../icons/launch.svg';
import Link, { LinkProps } from '../Link';

export interface ExternalLinkProps extends LinkProps {
}

const ExternalLink: FC<ExternalLinkProps> = (props) => (
  <Link RightIcon={LaunchIcon} target="_bank" {...props} />
);

export default ExternalLink;
